module.exports = __webpack_public_path__ + "assets/img/warrior-name-8124feba.png";